export default {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
}



// WEBPACK FOOTER //
// ./src/EditPanel/formItemLayout.js